import script from "./BookingHome.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingHome.vue?vue&type=script&setup=true&lang=js"

import "./BookingHome.vue?vue&type=style&index=0&id=3fc43ed1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fc43ed1"]])

export default __exports__